<div class="main-container">
  <div class="configurator-popup">
    <wlm-map-popup-wrapper
      [showArrowIcon]="true"
      [showSpinner]="false"
      [customTitle]="T_SCOPE + (isEditMode ? '.title-edit' : '.title') | translate"
      [popupWidth]="'220px'"
      (popupClose)="closePopup()"
    >
      <ng-container popup-content>
        <div class="popup-content">
          <div class="initial-container">
            <label class="label-container">{{ T_SCOPE + '.label-name' | translate }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                type="text"
                [placeholder]="T_SCOPE + '.label-name' | translate"
                [(ngModel)]="initialModel.styleName"
                (ngModelChange)="updateModelField('styleName', $event)"
              />
            </mat-form-field>
          </div>
          <div class="initial-container">
            <label class="label-container">{{ T_SCOPE + '.layer' | translate }}</label>
            <mat-form-field appearance="outline">
              <mat-select
                [(ngModel)]="initialModel.objectType"
                (ngModelChange)="onNeTypeChange($event)"
                [placeholder]="T_SCOPE + '.layer' | translate"
              >
                <mat-option *ngFor="let ne of neTypes" [value]="ne.networkElementTypeId">
                  {{ ne.networkElementTypeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="initial-container">
            <label class="label-container">{{ T_SCOPE + '.attributes' | translate }}</label>
            <mat-form-field appearance="outline" class="attribute-select">
              <mat-select
                [(ngModel)]="initialModel.fieldName"
                [placeholder]="T_SCOPE + '.attributes' | translate"
                (selectionChange)="onAttributeChange($event.value)"
              >
                <mat-option *ngFor="let attr of attributeOptions" [value]="attr.name">
                  <span class="truncate-text" [title]="attr.alias">{{ attr.alias }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="initial-container" *ngIf="attributeIsNumeric">
            <label class="label-container">{{ T_SCOPE + '.type' | translate }}</label>
            <div class="style-list">
              <div
                class="style-item"
                *ngFor="let lt of filteredLayerTypes"
                (click)="onLayerTypeSelect(lt.type)"
                [class.selected]="initialModel.layerType === lt.type"
              >
                <p>{{ lt.label | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </wlm-map-popup-wrapper>
  </div>

  <div
    class="configurator-popup"
    *ngIf="initialModel.layerType && !isThematicConfiguratorPopupClosed"
  >
    <wlm-thematic-configurator-popup
      [isEditMode]="isEditMode"
      [layerType]="initialModel.layerType"
      [model]="model"
      [uom]="uom"
      [metadata]="metadata"
      [isValid]="isValid"
      (popupClose)="closeNewThematicPopup()"
    ></wlm-thematic-configurator-popup>
  </div>
</div>
